<template>
  <div class="news-page">
    <div class="container">
      <NewsWidget :limit="9" />
    </div>
  </div>
</template>

<script>
import NewsWidget from "@/components/news/NewsWidget";

export default {
  name: "NewsList",
  components: {
    NewsWidget
  }
};
</script>

<style lang="scss">
.news-page {
  min-height: 1000px;
}
</style>
